import { onBeforeMount } from "vue";
//@ts-ignore
import { useModalStore } from "@store/ModalStore";
export function useModals() {
  var modalStore = useModalStore();
  function openAndReturnTo(fromModal, toModal, payload) {
    modalStore.openAndReturnTo({
      fromModal,
      toModal,
      payload
    });
  }
  var openModalOnPageReload = () => {
    modalStore.openModalOnPageReload();
  };
  var setShowModal = modal => {
    modalStore.setShowModal(modal);
  };
  onBeforeMount(() => {
    openModalOnPageReload();
  });
  return {
    setShowModal,
    openAndReturnTo
  };
}